import { render, staticRenderFns } from "./AppAuthenticationChallenge.vue?vue&type=template&id=8f1c8452&"
import script from "./AppAuthenticationChallenge.vue?vue&type=script&lang=ts&"
export * from "./AppAuthenticationChallenge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports